import toyota from './brands/toyota';
import brandDefault from './brands/default';
import honda from './brands/honda';
import hyundai from './brands/hyundai';
import kia from './brands/kia';
import mazda from './brands/mazda';
import infiniti from './brands/infiniti';
import chevrolet from './brands/chevrolet';
import mitsubishi from './brands/mitsubishi';
import ford from './brands/ford';
import nissan from './brands/nissan';
import lincoln from './brands/lincoln';
import cjdr from './brands/cjdr';


const brands = {
  modules: {
    brandDefault,
    toyota,
    honda,
    hyundai,
    kia,
    mazda,
    infiniti,
    chevrolet,
    mitsubishi,
    ford,
    nissan,
    lincoln,
    cjdr
  },
}


export default brands